import React from "react";
import { Box, Icon } from "@chakra-ui/react";
import { Section } from "components/section";
import { BookDemoButton } from "components/event-tracking";
import { FadeIn } from "ui/animations";
import { TextTitle } from "ui/text";
import { AidDemoVideo } from "./aid-demo-video";

export function SpotlightSvg() {
  return (
    <Icon width="100%" height="auto" fill="none" viewBox="0 0 1512 773" pos="absolute" bottom={0} left={0} right={0}>
      <g clipPath="url(#de-hero-a)" filter="url(#de-hero-b)">
        <Box as="ellipse" cx="756" cy="1382" fill="new.violet.900" rx="1081" ry="855" />
      </g>
      <defs>
        <clipPath id="de-hero-a">
          <path fill="#fff" d="M0 0h1512v773H0z" />
        </clipPath>
        <filter
          id="de-hero-b"
          width="1537"
          height="2510"
          x="0"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_8370_54573" stdDeviation="200" />
        </filter>
      </defs>
    </Icon>
  );
}

type HeroProps = {
  eyebrow: string;
  title: string;
  description: string;
};

export function AiDecisioningHero({ eyebrow, title, description }: HeroProps) {
  return (
    <Section
      bg="new.violet.950"
      themeBgColor="new.violet.950"
      theme="dark"
      pt={{ base: "big", md: "biggest" }}
      pb={{ base: "huge", md: "huger" }}
      pos="relative"
    >
      <SpotlightSvg />

      <Box pos="relative">
        <FadeIn>
          <TextTitle
            theme="dark"
            size="xl"
            chip={{ text: eyebrow }}
            title={title}
            titleAs="h1"
            description={description}
            descriptionAs="h2"
            descriptionMaxW="770px"
            actions={<BookDemoButton />}
            align="center"
          />
        </FadeIn>

        <FadeIn delay={0.25} duration={0.4}>
          <AidDemoVideo borderColor="transparent" boxShadow="md" />
        </FadeIn>
      </Box>
    </Section>
  );
}
